var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartBox",staticClass:"chartBox"},[_c('div',{ref:"main",staticStyle:{"width":"300px","height":"300px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }